import { expr } from "jquery"
import { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

 const  UserAuthorisation=()=>{

    const [orggenie_Error_Authorization, setOrggenie_Error_Authorization] = useState('');
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

    useEffect(() => { GetMasterSystemAlertList('Orggenie_Error_Authorization', 1) }, []);
    async function GetMasterSystemAlertList(message, type) {
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message && type == 1) {
                setOrggenie_Error_Authorization(msg?.Desc);
            }
        }); 
    }
    return (
        <div>
            <div className="container-fluid">
                <div className="row g-3">
                    <div className="error-container">
                        <div className="error-wrapper">
                            <div className="error-inner text-center">
                                <img className="light-image" src="images/notAuthorized.png" alt="" />
                                <h3 className="dark-inverted">Lost, are we?</h3>
                                <p>
                                    {orggenie_Error_Authorization}
                                </p>
                                <div className="button-wrap">
                                    <Link to='/' className="button h-button is-primary is-elevated">Return to Login</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
export default UserAuthorisation;